import {type PermissionStatusFilter} from './permissionMetadata'

type Props = {
  value: PermissionStatusFilter
  onChange: (value: PermissionStatusFilter) => void
}

export function PermissionStatusSelect({value, onChange}: Props) {
  return (
    <label className='flex items-center gap-2 text-xs font-semibold text-gray-600'>
      Status das permissões
      <select
        aria-label='Status das permissões'
        value={value}
        onChange={(event) => onChange(event.target.value as PermissionStatusFilter)}
        className='h-9 rounded-lg border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
      >
        <option value='active'>Somente ativas</option>
        <option value='inactive'>Somente inativas</option>
        <option value='all'>Todas</option>
      </select>
    </label>
  )
}
